import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.NewRequestPopup.Content', {
    title: 'Create new',
    headerButton: 'Create',
    searchPlaceholder: 'Search...',
    readonlyBadge: 'Read-only',
    integrationDisconnected: 'Disconnected',
    airwallexDisconnected: 'Disconnected from Airwallex',
    amCaptureBadge: 'ApprovalMax Capture',
    noResults: `Looks like you're not a Requester in some approval workflows. If needed, please contact the Organisation Administrators to get access.`,
});
